/**
 * The heading of a section on a detail-style page, as the generated detail views render it over
 * each Paper: small caps in the secondary colour.
 */
export const sectionHeadingSx = {
  fontSize: '0.8125rem',
  textTransform: 'uppercase' as const,
  color: 'text.secondary',
  letterSpacing: '0.05em',
};
